import React from "react";
import { useAuth } from "../hooks/useAuth";
import { Form } from "react-final-form";
import { Routes } from "../../../constants/routes";
import Typography from "@material-ui/core/Typography";
import FormLink from "../../../components/FormLink";
import { loginFormValidator } from "../utils/validators/loginForm";
import LoginForm from "./forms/LoginForm";
import { useLocation } from "react-router";

export default function LoginWidget() {
  const {
    actions: { login },
  } = useAuth();
  const { state: { email } = {} } = useLocation<{ email?: string }>();

  return (
    <>
      <Form
        onSubmit={login}
        validate={loginFormValidator}
        component={LoginForm}
        initialValues={{
          email,
        }}
      />
      <Typography component="p" align="center">
        Don’t have an account?{" "}
        <FormLink to={`/${Routes.REGISTER}`}>Sign Up</FormLink>
      </Typography>

      <Typography component="p" align="center" style={{ marginTop: 16 }}>
        This site is protected by reCAPTCHA and the Google{" "}
        <a href="https://policies.google.com/privacy">Privacy Policy</a> and{" "}
        <a href="https://policies.google.com/terms">Terms of Service</a> apply.
      </Typography>
    </>
  );
}
